import React from 'react';
import { Container, Row, Col } from '../components/grid';
import {
  Heading1, Heading3, Paragraph, Hr, LinkStyled,
} from '../components/typography';
import { Image } from '../components/Image';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Hjaelpemidler">
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading1>Hjælpemidler til kasser mm.</Heading1>
        </Col>
        <Col xs={12} sm={3} textCenter>
          <Image name="oel-vand.flaskevogne.gif" alt="Rullestativ til øl og sodavands kasser" width="196" height="200" />
        </Col>
        <Col xs={12} sm={9}>
          <Heading3>Flaskevogne</Heading3>
          <Paragraph>
            Flaskevogn til fire skråtstillede øl- og sodavandskasser med (30 stk. glasflasker eller 24 stk. plastikflasker).
          </Paragraph>
          <Paragraph>
            Kan købes hos: Scan-Flex Stålreoler ApS<br />
            Adresse: Højvangsvej 11<br />
            Postboks 15<br />
            4340 Tølløse <br />
            Telefon: +45 5918 6363 <br />
            Mobil: <br />
            Website: <LinkStyled external to="http://butik.scan-flex.dk/shop/flaskevogn-til-4-1018p.html" title="Link til flaskevogn">Scan Flex</LinkStyled><br />
            E-mail: <LinkStyled anchor to="mailto:scan-flex@mail.tele.dk">scan-flex@mail.tele.dk</LinkStyled><br />
            CVR nr.: 87137015
          </Paragraph>
        </Col>
      </Row>
      <Hr />
      <Row>
        <Col xs={12} sm={3} textCenter>
          <Image name="oel-vand.oelhunde.gif" alt="ølkasse vogn" />
        </Col>
        <Col xs={12} sm={9}>
          <Heading3>Ølkasse-vogn</Heading3>
          <Paragraph>
            Kan købes hos: <br />
            Dansk Niels Bo <br />
            Vognmagervej 10 <br />
            Snoghøj <br />
            DK-Fredericia <br />
            Tlf: 7594 5800 <br />
            Website: <LinkStyled external to="https://www.nielsbo.dk/products/ol-kassevogne">nielsbo.dk | ølkasse-vogn</LinkStyled><br />
            Email: <LinkStyled anchor to="mailto: dnb@nielsbo.dk">dnb@nielsbo.dk</LinkStyled>
          </Paragraph>
        </Col>
      </Row>
      <Hr />
      <Row>
        <Col xs={12} sm={3} textCenter>
          <Image name="oel-vand.elektrisk-saekkevogn.png" alt="Elektrisk Sækkevogn" maxHeight="350px" imageHeight="350px" />
        </Col>
        <Col xs={12} sm={9}>
          <Heading3>Elektrisk sækkevogn</Heading3>
          <Paragraph>
            Kan købes hos: <br />
            Dansk Niels Bo <br />
            Vognmagervej 10 <br />
            Snoghøj <br />
            DK-Fredericia <br />
            Tlf: 7594 5800 <br />
            Website: <LinkStyled external to="https://www.nielsbo.dk/collections/eltrappesaekkevogne-sano-liftkar_eltrappesaekkevogne-reevne-op-til-170-kg">nielsbo.dk | sækkevogne</LinkStyled><br />
            Email: <LinkStyled anchor to="mailto: dnb@nielsbo.dk">dnb@nielsbo.dk</LinkStyled>
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
